export const pixel7MediaQuery = `@media only screen and (max-width: 420px)`;
